import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import Layout from "@/components/Layout";
import Cover from "@/pages/Cover";
import Ivory from "@/pages/Ivory";
import Bronze from "@/pages/Bronze";
import QZip from "@/pages/QZip";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import Contact from "@/pages/Contact";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Cover />} />
                <Route path="ivory" element={<Ivory />} />
                <Route path="bronze" element={<Bronze />} />
                <Route path="qzip" element={<QZip />} />
                <Route path="about" element={<About />} />
                <Route path="shop" element={<Shop />} />
                <Route path="contact" element={<Contact />} />
                <Route path="checkout/success" element={<Success />} />
                <Route path="checkout/cancel" element={<Cancel />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </AdminAuthProvider>
      </CartProvider>
    </div>
  );
}

export default App;
